<!--
 * @FileDescription: Legal Info Page
 * @Author: jianguo Wang
 * @Date: 2025-01-07
-->
<template>
  <div class="page-wrapper">
    <headerPart />
    <main class="main-content">
      <div class="content-container">
        <router-link to="/" class="back-link">
          <svg class="back-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back to Home
        </router-link>

        <article class="content-card">
          <h1 class="page-title">Legal Information</h1>

          <div class="content-body">
            <!-- Company Registration -->
            <section class="content-section">
              <h2 class="section-heading">Company Registration</h2>
              <div class="info-grid">
                <div class="info-item">
                  <p class="info-label">Legal Name</p>
                  <p class="info-value">Vircard Limited</p>
                </div>
                <div class="info-item">
                  <p class="info-label">Entity Type</p>
                  <p class="info-value">Colorado Corporation</p>
                </div>
                <div class="info-item">
                  <p class="info-label">Entity ID</p>
                  <p class="info-value">20251675169</p>
                </div>
                <div class="info-item">
                  <p class="info-label">Document Number</p>
                  <p class="info-value">20251675169</p>
                </div>
              </div>
              <div class="info-item full-width">
                <p class="info-label">Registered Address</p>
                <p class="info-value">1312 17TH ST UNIT NUM-2955, Denver, COLORADO, USA</p>
              </div>
            </section>

            <!-- MSB Registration -->
            <section class="content-section">
              <h2 class="section-heading">MSB Registration (FinCEN)</h2>
              
              <!-- <div class="notice-box">
                <p class="notice-title">FinCEN Notice:</p>
                <p class="notice-text">
                  Information contained on this transcript has been provided to FinCEN by the money services business
                  registrant. FinCEN does not recommend, approve, or endorse any business that registers as a money
                  services business. Any such claim and similar claims are false and may be part of a scam or attempt to
                  deceive consumers.
                </p>
              </div> -->

              <div class="info-grid">
                <div class="info-item">
                  <p class="info-label">MSB Registration Number</p>
                  <p class="info-value">31000303178151</p>
                </div>
                <!--<div class="info-item">
                  <p class="info-label">Registration Type</p>
                  <p class="info-value">Initial Registration</p>
                </div>-->
                <div class="info-item">
                  <p class="info-label">Legal Name</p>
                  <p class="info-value">Vircard Limited</p>
                </div>
                <div class="info-item">
                  <p class="info-label">DBA Name</p>
                  <p class="info-value">—</p>
                </div>
              </div>

              <div class="info-item full-width">
                <p class="info-label">Business Address</p>
                <p class="info-value">1312 17TH ST UNIT NUM-2955, Denver, COLORADO, USA</p>
              </div>

              <!-- <p class="disclaimer-small">
                The MSB Registrant Search Web page, which is updated on a weekly basis, contains entities that have
                registered as Money Services Businesses (MSBs) pursuant to the Bank Secrecy Act (BSA) regulations at 31
                CFR 1022.380(a)-(f), administered by the Financial Crimes Enforcement Network (FinCEN). Information
                contained on this site has been provided by the MSB registrant. FinCEN does not verify information
                submitted by the MSB.
              </p> -->
            </section>

            <!-- Business Nature & Scope -->
            <section class="content-section">
              <h2 class="section-heading">Business Nature & Scope</h2>
              <p class="section-paragraph">
                Vircard Limited is engaged in technology services and financial solutions, providing innovative products
                and services to global customers. The company operates as a money services business registered with
                FinCEN and complies with all applicable federal and state regulations.
              </p>
            </section>

            <!-- Regulatory Status -->
            <section class="content-section">
              <h2 class="section-heading">Regulatory Status</h2>
              <p class="section-paragraph">
                The company complies with all applicable laws and regulations related to its business operations and
                holds all necessary licenses and registration documents. Vircard Limited is registered as a Money
                Services Business (MSB) with the Financial Crimes Enforcement Network (FinCEN) and adheres to all Bank
                Secrecy Act (BSA) requirements.
              </p>
            </section>

            <!-- Intellectual & Industrial Property -->
            <section class="content-section">
              <h2 class="section-heading">Intellectual & Industrial Property</h2>
              <p class="section-paragraph">
                The Vircard brand, logos, website design, software, and all content are owned by the company. No
                reproduction, distribution, or commercial use is permitted without authorization.
              </p>
            </section>

            <!-- Privacy & Compliance -->
            <section class="content-section">
              <h2 class="section-heading">Privacy & Compliance</h2>
              <p class="section-paragraph">
                For information about how we process personal data, please refer to our
                <router-link to="/privacy" class="inline-link">Privacy Policy</router-link>.
              </p>
            </section>

            <!-- Disclaimer -->
            <section class="content-section">
              <h2 class="section-heading">Disclaimer</h2>
              <p class="section-paragraph">
                Vircard assumes no responsibility for any damages that may arise from transactions between users and
                third parties. However, we will take necessary measures within the framework of security, privacy, and
                legal obligations. If an error or incomplete information is detected on this site, the registrant should
                follow the appropriate instructions for correcting a Registration of Money Services Business (RMSB)
                form.
              </p>
            </section>

            <div class="footer-meta">
              <p class="last-updated">Last Updated: January 2025</p>
            </div>
          </div>
        </article>
      </div>
    </main>
    <footerPart />
  </div>
</template>

<script>
import headerPart from "../components/header.vue";
import footerPart from "../components/footer.vue";

export default {
  name: "LegalInfoPage",
  components: {
    headerPart,
    footerPart,
  },
};
</script>

<style scoped>
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  background: #f9fafb;
}

.content-container {
  max-width: 1024px;
  margin: 0 auto;
  padding: 48px 24px;
  text-align: left;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #4b5563;
  text-decoration: none;
  transition: color 0.2s;
  margin-bottom: 32px;
}

.back-link:hover {
  color: #8b3a3a;
}

.back-icon {
  width: 16px;
  height: 16px;
}

.content-card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  padding: 48px;
  text-align: left;
}

.page-title {
  font-size: 30px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 32px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.content-body {
  display: flex;
  flex-direction: column;
  gap: 32px;
  color: #374151;
  line-height: 1.6;
}

.content-section {
  display: flex;
  flex-direction: column;
}

.section-heading {
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 16px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}

.info-item {
  display: flex;
  flex-direction: column;
}

.info-item.full-width {
  grid-column: 1 / -1;
}

.info-label {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 4px;
}

.info-value {
  font-size: 16px;
  font-weight: 500;
  color: #111827;
}

.notice-box {
  background: #fffbeb;
  border-left: 4px solid #d97706;
  border-radius: 0 8px 8px 0;
  padding: 20px;
  color: #92400e;
  margin-bottom: 24px;
}

.notice-title {
  font-weight: 700;
  margin-bottom: 8px;
}

.notice-text {
  line-height: 1.6;
}

.disclaimer-small {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.6;
  margin-top: 16px;
}

.section-paragraph {
  font-size: 16px;
  color: #374151;
  line-height: 1.6;
}

.inline-link {
  color: #8b3a3a;
  font-weight: 500;
  text-decoration: none;
}

.inline-link:hover {
  text-decoration: underline;
}

.footer-meta {
  padding-top: 24px;
  margin-top: 32px;
  border-top: 1px solid #e5e7eb;
}

.last-updated {
  font-size: 14px;
  color: #6b7280;
}

@media screen and (max-width: 768px) {
  .content-container {
    padding: 32px 16px;
  }

  .content-card {
    padding: 32px 24px;
  }

  .page-title {
    font-size: 24px;
  }

  .section-heading {
    font-size: 18px;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .section-paragraph {
    font-size: 14px;
  }
}
</style>
